module.exports = __webpack_public_path__ + "img/cut.5b0b166e.svg";